{
  "version": 1,
  "asset_id": "23b53a3a-34ad-4b11-8f22-397fd712acd7",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/23b53a3a-34ad-4b11-8f22-397fd712acd7/ind-automotive-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/23b53a3a-34ad-4b11-8f22-397fd712acd7/ind-automotive-1200.avif",
  "original_filename": "ind-automotive-1200.avif",
  "size": 24520,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:55Z"
}
